/**
 * @function escapeRegExpSpecialCharacters formats a string that is used to create a new RegExp()
 * and makes sure special characters are prepended with `\\` to avoid creating faulty regular expressions.
 * @param {string} text
 * @returns formated string
 */

export const escapeRegExpSpecialCharacters = text =>
  text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
